import React, { useState, useEffect } from "react";
import { Button, Heading, HeadingSize, Link, Modal, ModalSizes } from "@sunwing/wvi-components";
import { getCookie, setCookie } from "../../../utils";
import { WVI_REDIRECT_MODAL_COOKIE_NAME } from "../../../const/const";
import { RCL as useTranslation } from "../../RCL";
import * as styles from "./GeolocationRedirectModal.module.scss";

const GeolocationRedirectModal = () => {
	const [showRedirectModal, setShowRedirectModal] = useState(false);
	const content = {
		heading: useTranslation({ searchKey: "wvi-geolocation-redirect-modal-heading" }),
		body: useTranslation({ searchKey: "wvi-geolocation-redirect-modal-body" }),
		redirect: useTranslation({ searchKey: "wvi-geolocation-redirect-modal-redirect" }),
		redirectLink: useTranslation({ searchKey: "wvi-geolocation-redirect-modal-redirect-link" }),
		stay: useTranslation({ searchKey: "wvi-geolocation-redirect-modal-stay" }),
	};

	const handleCloseRedirectModal = () => {
		setShowRedirectModal(false);

		let nextWeek = new Date();
		nextWeek = new Date(nextWeek.getTime() + 1000 * 60 * 60 * 24 * 7);

		setCookie(WVI_REDIRECT_MODAL_COOKIE_NAME, "closed", "/", undefined, nextWeek);
	};

	useEffect(() => {
		setShowRedirectModal(getCookie(WVI_REDIRECT_MODAL_COOKIE_NAME) === true);
	}, []);

	if (!showRedirectModal) {
		return null;
	}

	return (
		<Modal
			implementation="react"
			className={styles.modal}
			size={ModalSizes.xlg}
			isOpen={showRedirectModal}
			onClose={handleCloseRedirectModal}
			isDismissible={false}>
			<div className={styles.content}>
				<Heading className={styles.heading} size={HeadingSize.md} Tag="h2">
					{content.heading}
				</Heading>
				<div className={styles.message}>{content.body}</div>

				<Button as="a" variant="action" href={content.redirectLink}>
					{content.redirect}
				</Button>

				<Link
					className={styles.actionCancel}
					href="#"
					variant="primary"
					onClick={e => {
						e.preventDefault();
						handleCloseRedirectModal();
					}}>
					{content.stay}
				</Link>
			</div>
		</Modal>
	);
};

export { GeolocationRedirectModal };
